require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-food-trucks-at-the-bend.json") })
        }
      }, "path---news-food-trucks-at-the-bend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-food-trucks-at-the-bend!./.cache/json/news-food-trucks-at-the-bend.json
// module id = 809
// module chunks = 231608221292675